module.exports = __webpack_public_path__ + "img/36220C_C6C391_8C844A_8B7B4C-256px.b80a6e92.png";